import React from 'react'
import injectSheet from 'react-jss'
import styles from './current-entry.styles'
import { Cell, TableRow } from 'pobble-components/dist/table'
import { BulkCheckbox } from 'pobble-components/dist/bulk-action'
import CircleStatus from 'pobble-components/dist/circle-status'
import ContextMenu from './context-menu/context-menu.container'
import classNames from 'classnames'

import Button from 'pobble-components/dist/button'

const CurrentEntry = ({
  classes,
  id,
  title,
  invitedAt,
  invitedBy,
  conclusion,
  pending,
  seen,
  url,
  school,
  onInvitationClick,
  index
}) => (
  <TableRow pending={pending}>
    <Cell
      center
      className={classNames(classes.checkboxChell, {
        [classes.unseen]: !seen
      })}>
      <BulkCheckbox id={id} />
    </Cell>
    <Cell className={classes.date}>{invitedAt}</Cell>
    <Cell>{invitedBy}</Cell>
    <Cell>{school}</Cell>
    <Cell>
      <Button
        className={(classes.btn, `metrics__moderation-inv-title--${index}`)}
        simple
        action={() => onInvitationClick(url, id)}>
        {title}
      </Button>
    </Cell>
    <Cell className={classes.center}>
      <CircleStatus status={conclusion} />
    </Cell>
    <Cell right className={`metrics__moderation-inv-context--${index}`}>
      <ContextMenu id={id} />
    </Cell>
  </TableRow>
)

export default injectSheet(styles)(CurrentEntry)
